/* eslint-disable object-shorthand */
/* eslint-disable no-param-reassign */
/* eslint-disable padding-line-between-statements */
import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { MLModalService } from 'ml-portals-services-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { MLHVQDiscrepancyPropertyColomnComponent } from 'gw-capability-quoteandbind-pa-react';
import { SpousePopoverComponent, MLModifierComponent } from 'ml-components-common-react';
import { MLDriverVehicleUtil } from 'ml-portals-util-react';
import { platformMessages } from 'ml-components-platform-react';
import { useTranslator } from '@jutro/locale';

import MLCRDriversGoodStudentComponent from './MLCRDriversGoodStudentComponent/MLCRDriversGoodStudentComponent';

import metadata from './MLCRDriversValidationComponent.metadata.json5';
import styles from './MLCRDriversValidationComponent.module.scss';
import messages from './MLCRDriversValidationComponent.messages';

const DRIVER_MODIFIERS_PATH = 'driverModifiers_ML.modifiers';

function MLCRDriversValidationComponent(props) {
    const {
        submissionVM,
        discrepanciesVM,
        driversVMForDiscrepancy,
        driversVM,
        onValidate,
        updateWizardData,
        showValidationErrors,
        onUpdateModifiersUnsuccessful,
        driversMarriedNoSpouse,
        discrepanciesResolved
    } = props;
    const { refreshData } = useDataRefresh();
    const [discrepancyUpdated, setDiscrepancyUpdated] = useState(false);
    const { showProgressDialog } = MLModalService();
    const { authHeader } = useAuthentication();
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const {
        setModifierEditMode,
        setSpousesForDriver,
    } = MLDriverVehicleUtil();
    const [occupationtypelist, updateOccupationtypelist] = useState();
    const [educationtypelist, updateEducationtypelist] = useState();

    // This is for triggering page re-render when user has updated discrepancy value.
    // As requirement needed to show Add Spouse field when Marital status has updated
    // And DriversVM has no direct connection with DiscrepanciesVM, so need to manualy
    // Trigger page re-render to make sure hasSelectedMarriedStatus() is called
    useEffect(() => {
        if (discrepancyUpdated) {
            setDiscrepancyUpdated(false);
        }
    }, [discrepancyUpdated]);

    const isModernProduct = _.get(submissionVM, "isModernProduct_Ext.value", false);
    const translator = useTranslator();

     useEffect(() => {
            const initOccupationTypeList = () => {
                let categories;
                if(isModernProduct){
                    categories = driversVM[0].occupation_Ext.aspects.availableValues.filter((value) => {
                        return (value.code.endsWith('_np') || value.code === 'military' || value.code === 'other');
                    });
                }
                else{
                    categories = driversVM[0].occupation_Ext.aspects.availableValues.filter((value) => {
                        return (!value.code.endsWith('_np'));
                    });
                }
    
                const categoryCodes = categories.map((category) => ({
                    code: category.code,
                    name: translator({
                        id: category.name,
                        defaultMessage: category.name
                    })
                }));
    
                updateOccupationtypelist(categoryCodes);
            }

         const initEducationTypeLists = () => {
             let categories;
             categories = driversVM[0].highestEducationLevel_Ext.aspects.availableValues.filter((value) => {
                 return value.code;
             });

             const categoryCodes = categories.map((category) => ({
                 code: category.code,
                 name: translator({
                     id: category.name,
                     defaultMessage: category.name
                 })
             }));

             updateEducationtypelist(categoryCodes)

            }
    
            initOccupationTypeList();
            initEducationTypeLists();
        }, []);

    // Modifiers
    if (driversVM && driversVM.length > 0) {
        driversVM.forEach((driverVM) => {
            const driverModifiers = _.get(driverVM, DRIVER_MODIFIERS_PATH);

            // Update the modifier to make sure the validation will be  
            // triggered when there has defaulted value from CP bridged Quote
            if (driverModifiers) {
                driverModifiers.value?.forEach(
                    (mod) => {
                        mod.savedFromPortal = true;
                        mod.editMode_ML = true;
                    }
                );
            }
        });
    }

    const driverList = driversVM.map((d) => d.value);

    const disableValidationForDependentModifiers = (mod) => {
        if (mod) {
            driverList.forEach((driver) => {
                if (!_.isEmpty(driver.driverModifiers_ML)) {
                    driver.driverModifiers_ML.modifiers.forEach((modifier) => {
                        if (modifier.isDependentModifier_ML) {
                            modifier.editMode_ML = false;
                        }
                    });
                }
            });
        }
    };

    const initVehicleValue = (vehicle) => {
        if (!vehicle.value_ML || vehicle.value_ML.amount === 0) {
            vehicle.value_ML = {};
        }
        vehicle.tempID = (vehicle.publicID) ? vehicle.publicID : vehicle.tempID;
    };

    const updateModifiers = (mod) => {
        _.set(mod, 'updated.value', true);

        const setEditMode = (editMode) => {
            submissionVM.value.lobData.personalAuto.coverables.drivers.forEach((driver) => {
                driver.editMode_ML = editMode;
            });
            submissionVM.value.lobData.personalAuto.coverables.vehicles.forEach((vehicle) => {
                vehicle.editMode_ML = editMode;
            });

            submissionVM.value.lobData.personalAuto.modifiers_ML.lineModifiers.forEach((lineModifier) => {
                lineModifier.editMode_ML = editMode;
            });
        };

        disableValidationForDependentModifiers(mod);
        // Disable validation so we can update the model and the driver modifiers with it
        setEditMode(false);
        _.set(submissionVM, 'bypassValidationForComprater_Ext', true);
        const submissionLoadPromise = LoadSaveService.updateModifiers(submissionVM.value, authHeader);
        setTimeout(() => {
            showProgressDialog(platformMessages.syncing, submissionLoadPromise, true);
        }, 100);
        submissionLoadPromise.then((qdd) => {
            submissionVM.value.lobData.personalAuto.coverables.drivers.length = 0;
            const sortedDrivers = _.sortBy(qdd.lobData.personalAuto.coverables.drivers, (driver) => {
                if (driver.publicID) {
                    return _.toInteger(driver.publicID.split(':')[1]);
                }
                return undefined;
            });
            sortedDrivers.forEach((driver) => {
                if (driver.person) {
                    driver.person = submissionVM.value.findPerson(submissionVM.value, driver.person);
                }
            });
            _.set(submissionVM, 'value.lobData.personalAuto.coverables.drivers', sortedDrivers);
            setSpousesForDriver(driverList);
            const drivers = submissionVM?.value?.lobData?.personalAuto?.coverables?.drivers;
            if (Array.isArray(drivers)) {
                const targetCodes = [
                    "PADriverSignalProgramPhoneNumber_Ext"
                ];

                drivers.forEach((driver) => {
                    const modifiers = driver?.driverModifiers_ML?.modifiers;
                    if (Array.isArray(modifiers)) {
                        modifiers.forEach((modifier) => {
                            if (modifier && targetCodes.includes(modifier.codeIdentifier_ML)) {
                                modifier.chosenTermValue = null;
                                modifier.isVisible_ML = false
                                modifier.isInputValueRequired_ML = false
                                modifier.editMode_ML = false
                                modifier.savedFromPortal = false
                            }
                        });
                    }
                });
            }
            // Not sure we should do this in CR flow as it will clear out the vehicles, re-enable when confirm behavior is correct
            // if (mod?.codeIdentifier_ML?.value === 'PADriverSignalProgram_Ext') {
            //     submissionVM.value.lobData.personalAuto.coverables.vehicles.length = 0;
            //     qdd.lobData.personalAuto.coverables.vehicles.forEach((updatedVehicle, index) => {
            //         initVehicleValue(updatedVehicle);
            //         submissionVM.value.lobData.personalAuto.coverables.vehicles.push(updatedVehicle);
            //     });
            // }
        }, (error) => {
            console.error(error);
            // Update modifier will failed if DTO validation error is returned, has to let the user know
            // what is going on and let user to fix the issue before having another update modifier action
            onUpdateModifiersUnsuccessful();
        }).finally(() => {
            setEditMode(true);
            setModifierEditMode(submissionVM.value.lobData.personalAuto.coverables.drivers, true);
            updateWizardData(submissionVM);
        });
    };

    // Driver discrepancy
    const driverHasDiscrepancy = (driverVM) => {
        return discrepanciesVM.some((disVM) => {
            const publicId = disVM.publicId;
            return driverVM.value.publicID === publicId;
        });
    };

    const getDriverDiscrepancy = (driverVM) => {
        if (driverHasDiscrepancy(driverVM)) {
            const driverDiscrepancyVM = discrepanciesVM.find((disVM) => {
                return driverVM.value.publicID === disVM.publicId;
            });

            return sortDiscrepancyProperty(driverDiscrepancyVM.propertyVMs);
        }
    };

    const sortDiscrepancyProperty = (ptyVMs) => {
        // Make the Martial Status to display at the last position of the discrepancy properties
        return ptyVMs.sort((a, b) => {
            try {
                const aHasMaritalStatus = a?.value && a?.value?.title === 'Marital Status';
                const bHasMaritalStatus = b?.value && b?.value?.title === 'Marital Status';

                if (aHasMaritalStatus && !bHasMaritalStatus) return 1;
                if (!aHasMaritalStatus && bHasMaritalStatus) return -1;
                return 0;
            } catch (e) {
                console.log('unexpected error', e);
            }
        });
    };

    const isBridgedAndDefaultedByHVQ = (driverVM) => {
        return !!driverVM.bridgedFromHVQ_ML?.value && false;
    };

    // Spouse
    const isMarriedStatus = (driverVM) => {
        return !!driverVM.maritalStatus_ML.value && driverVM.maritalStatus_ML.value.code === 'M';
    };

    const hasSelectedMarriedStatus = (ptyVM) => {
        const hasMaritalStatusDiscrepancy = ptyVM?.value?.title === 'Marital Status';
        if (!hasMaritalStatusDiscrepancy) {
            return false;
        }

        if ((ptyVM?.value?.hvqValue === 'Married/Civil Union' && ptyVM?.value?.keepHvqValue === true) || (ptyVM?.value?.quoteValue === 'Married/Civil Union' && ptyVM?.value?.keepHvqValue === false)) {
            return true;
        }

        return false;
    };

    const driverHasAValidSpouse = (driverVM) => {
        // driverList is a plain object of driver array, NOT a ViewModel
        return !_.isUndefined(driverVM.value.spouseID_ML) && driverList.some((driver) => driver.person.publicID === driverVM.value.spouseID_ML);
    };

    const marriedNoSpouseContainsDriver = (driverVM) => {
        return driversMarriedNoSpouse.some((driverPublicID) => driverPublicID === driverVM.publicID.value)
    }

    const shouldDisplaySpouse = (driverVM) => {
        const isDriverMarried = isMarriedStatus(driverVM);
        const driverHasDiscrepany = driverHasDiscrepancy(driverVM);

        if (driverHasDiscrepany) {
            const driverDiscrepanciesVM = getDriverDiscrepancy(driverVM);
            let shouldShowSpouse = false;
            driverDiscrepanciesVM.forEach((disVM) => {
                if (hasSelectedMarriedStatus(disVM) === true) {
                    shouldShowSpouse = true;
                }
            })
            if (!shouldShowSpouse && isDriverMarried ) {
                shouldShowSpouse = !driverHasAValidSpouse(driverVM) || marriedNoSpouseContainsDriver(driverVM);
            }
            return shouldShowSpouse;
        } else if (isDriverMarried) {
            return !driverHasAValidSpouse(driverVM) || marriedNoSpouseContainsDriver(driverVM);
        }
        return false;
    }


    const onSpouseUpdate = () => {
        updateWizardData(submissionVM);
        refreshData();
    }

    const handleDiscrepancyUpdate = (value, discrepancyPropertyVM, keepHvqValue, driverPublicID) => {
        const isMaritalStatusproperty = discrepancyPropertyVM.get('__propertyName').title === "Marital Status"
        if (isMaritalStatusproperty) {
            const hvqDiscrepancies_ML = _.get(submissionVM, 'hvqDiscrepancies_ML.personalAuto.drivers')
            hvqDiscrepancies_ML.value.map(hvq => {
                if (driverPublicID=== hvq.publicID) {
                    const { maritalStatus } = hvq
                    maritalStatus.keepHvqValue = value
                    return { ...hvq, maritalStatus }
                }
                return hvq
            })
            _.set(submissionVM, 'hvqDiscrepancies_ML.personalAuto.drivers', hvqDiscrepancies_ML)
        }
    }

    const shouldShowSchoolAddressForDriver = (driverVM) => {
        const modifiers = driverVM.driverModifiers_ML?.value?.modifiers;
        if (!Array.isArray(modifiers)) {
            return false;
        }
        const distantStudentMod = modifiers.find(
            (mod) => mod.codeIdentifier_ML === 'PADistantStudent_Ext'
        );
        if (!distantStudentMod) {
            return false;
        }
        _.set(driverVM, 'isSchoolAddressRequired_Ext', true);
        return distantStudentMod.chosenTermValue === 'true';
    };

    const createAddressOnChange = (driverVM) => (value, path) => {
        if (!path) {
            driverVM.schoolAddress_Ext = value;
        } else {
            _.set(driverVM, path, value);
        }
        updateWizardData(submissionVM);
    };

    const isHigherEducationRequired = (driver) => {
        const higherEducation = _.get(driver, 'highestEducationLevel_Ext.value');
        if (isModernProduct && (higherEducation === undefined || higherEducation === null)) {
            _.set(driver, 'partialDriverAdditionFlag_ML.value', false);
            return true;
        }
    }

    // Viewmodel Form
    const generateOverrides = () => {
        const data = driversVMForDiscrepancy.length > 0 ? driversVMForDiscrepancy : [];
        if (data.length > 0) {
            const sortedDriverData = _.sortBy(data, (driver) => {
                if (driver.publicID && driver.publicID.value) {
                    return _.toInteger(driver.publicID.value.split(':')[1]);
                }
                return undefined;
            });
            const driverOverrides = sortedDriverData.map((driverVM, index) => {
                return {
                    [`DriverName${index}`]: {
                        visible: !driverHasDiscrepancy(driverVM) || discrepanciesResolved,
                        content: driverVM.value.displayName
                    },
                    [`DiscrepancyProperty${index}`]: {
                        visible: driverHasDiscrepancy(driverVM) && !discrepanciesResolved,
                        discrepancyProperties: getDriverDiscrepancy(driverVM),
                        discrepancyOwnerTitle: driverVM.value.displayName,
                        showPropertyGroupDoubleBorderStyle: false,
                        discrepancyHasUpdated: (updated) => {
                            setDiscrepancyUpdated(updated)
                        },
                        discrepancyOwner: driverVM.value.publicID,
                        handleDiscrepancyUpdate
                    },
                    [`SpousePopoverComponent${index}`]: {
                        submissionVM: submissionVM,
                        driverVM: driverVM,
                        driverList: driverList,
                        visible: shouldDisplaySpouse(driverVM),
                        handleSpouseModelChange: onSpouseUpdate,
                        updateModifiers: updateModifiers,
                        onValidate: onValidate,
                        isPolicyChange: false,
                        isCompRaterSpouseFeature: true,
                        showValidationErrors
                    },
                    [`ModifierComponent${index}`]: {
                        driverModifiers: driverVM.driverModifiers_ML,
                        updateModifier: updateModifiers,
                        isFieldDefaultedByHvq: () => isBridgedAndDefaultedByHVQ(driverVM),
                        showValidationErrors: showValidationErrors,
                        onValidate: onValidate,
                        isCompRaterSpacing: true
                    },
                    [`schoolAddressContainer${index}`]: {
                        visible: shouldShowSchoolAddressForDriver(driverVM)
                    },
                    [`schoolAddressLookup${index}`]: {
                        id: 'schoolAddressLookup',
                        visible: shouldShowSchoolAddressForDriver(driverVM),
                        value: driverVM.schoolAddress_Ext,
                        onValueChange: createAddressOnChange(driverVM),
                        initialLockStateCity: false,
                        showValidationErrors: showValidationErrors
                    },                    
                    [`GoodStudentComponent${index}`]: {
                        submissionVM: submissionVM,
                        driverVM: driverVM,
                        isModelBridgedAndDefaultedByHVQ: () => isBridgedAndDefaultedByHVQ(driverVM)
                    },
                    [`occupation${index}`]: {
                        submissionVM: submissionVM,
                        visible: isModernProduct,
                        availableValues: occupationtypelist,
                        value: driverVM.occupation_Ext.value,
                        onValueChange: (value) => {_.set(driverVM, 'occupation_Ext.value', value);
                            updateWizardData(submissionVM);
                            refreshData();
                        }
                    },
                    [`occupationDefinitions${index}`]: {
                        visible: isModernProduct,
                        tooltipContent: messages.occupationDefinitionContent,
                        tooltipHeader: messages.occupationDefinitionTitle,
                        tooltipContentClassName: styles.occupationContentStyles,
                        tooltipHeaderClassName: styles.occupationHeaderStyle
                    },
                    [`educationContainer${index}`]: {
                        visible: _.get(submissionVM, "isModernProduct_Ext.value", false) &&
                            (driverVM.relationshipToInsured_ML?.value?.code === 'self' || driverVM.relationshipToInsured_ML?.value?.code === 'spouse'), 
                    },
                    [`educationLevel${index}`]: {
                        availableValues: educationtypelist,
                        value: driverVM.highestEducationLevel_Ext.value,
                        required: isHigherEducationRequired(driverVM),
                        onValueChange: (value) => {
                            _.set(driverVM, 'highestEducationLevel_Ext.value', value);
                            updateWizardData(submissionVM);
                            refreshData();
                        }
                    }
                };
            });
            return Object.assign({}, ...driverOverrides);
        }
        return {};
    };

    const overrideProps = {
        driversDiscrepancy: {
            data: driversVMForDiscrepancy
        },
        ...generateOverrides()
    };

    const resolvers = {
        resoolveCallbackMap: {
        },
        resolveComponentMap: {
            discrepancyPropertyComponent: MLHVQDiscrepancyPropertyColomnComponent,
            spousepopovercomponent: SpousePopoverComponent,
            goodStudentComponent: MLCRDriversGoodStudentComponent,
            modifiercomponent: MLModifierComponent,
        },
        resolveClassNameMap: styles
    }

    // Hide component when no discrepency
    if (driversVMForDiscrepancy.length === 0) {
        return null;
    }

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            showErrors={showValidationErrors}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
            callbackMap={resolvers.resoolveCallbackMap}
            onValidationChange={onValidate}
        />
    );

}

MLCRDriversValidationComponent.propTypes = {
    submissionVM: PropTypes.shape({}).isRequired,
    discrepanciesVM: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    driversVMForDiscrepancy: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    driversVM: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    showValidationErrors: PropTypes.bool.isRequired,
    isFieldDefaultedByHvq: PropTypes.func,
    onValidate: PropTypes.func.isRequired,
};
MLCRDriversValidationComponent.defaultProps = {
    isFieldDefaultedByHvq: undefined,
};
export default withRouter(MLCRDriversValidationComponent);